tinymce.Resource.add('tinymce.html-i18n.help-keynav.eu',
'<h1>Hasi teklatuaren nabigazioa</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Fokuratu menu-barra</dt>\n' +
  '  <dd>Windows edo Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Fokuratu tresna-barra</dt>\n' +
  '  <dd>Windows edo Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Fokuratu orri-oina</dt>\n' +
  '  <dd>Windows edo Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Fokuratu jakinarazpena</dt>\n' +
  '  <dd>Windows edo Linux: Alt+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Fokuratu testuinguruaren tresna-barra</dt>\n' +
  '  <dd>Windows, Linux edo macOS: Ktrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>Nabigazioa EIko lehen elementuan hasiko da: elementu hori nabarmendu egingo da, edo azpimarratu lehen elementua bada\n' +
  '  orri-oineko elementuaren bidea.</p>\n' +
  '\n' +
  '<h1>Nabigatu EIko atalen artean</h1>\n' +
  '\n' +
  '<p>EIko atal batetik hurrengora mugitzeko, sakatu <strong>Tabuladorea</strong>.</p>\n' +
  '\n' +
  '<p>EIko atal batetik aurrekora mugitzeko, sakatu <strong>Maius+Tabuladorea</strong>.</p>\n' +
  '\n' +
  '<p>EIko atal hauen <strong>Tabuladorea</strong> da:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>Menu-barra</li>\n' +
  '  <li>Tresna-barraren talde bakoitza</li>\n' +
  '  <li>Alboko barra</li>\n' +
  '  <li>Orri-oineko elementuaren bidea</li>\n' +
  '  <li>Orri-oneko urrats-kontaketa txandakatzeko botoia</li>\n' +
  '  <li>Orri-oineko marken esteka</li>\n' +
  '  <li>Orri-oineko editorearen tamaina aldatzeko heldulekua</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>EIko atal bat ez badago, saltatu egin da.</p>\n' +
  '\n' +
  '<p>Orri-oinak teklatuaren nabigazioa fokuratuta badago, eta alboko barra ikusgai ez badago, <strong>Maius+Tabuladorea</strong> sakatuz gero,\n' +
  '  fokua tresna-barrako lehen taldera eramaten da, ez azkenera.</p>\n' +
  '\n' +
  '<h1>Nabigatu EIko atalen barruan</h1>\n' +
  '\n' +
  '<p>EIko elementu batetik hurrengora mugitzeko, sakatu dagokion <strong>Gezia</strong> tekla.</p>\n' +
  '\n' +
  '<p><strong>Ezkerrera</strong> eta <strong>Eskuinera</strong> gezi-teklak</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>menu-barrako menuen artean mugitzen da.</li>\n' +
  '  <li>ireki azpimenu bat menuan.</li>\n' +
  '  <li>mugitu botoi batetik bestera tresna-barren talde batean.</li>\n' +
  '  <li>mugitu orri-oineko elementuaren bideko elementu batetik bestera.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p><strong>Gora</strong> eta <strong>Behera</strong> gezi-teklak</p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>mugitu menu bateko menu-elementuen artean.</li>\n' +
  '  <li>mugitu tresna-barrako menu gainerakor bateko menu-elementuen artean.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p><strong>Gezia</strong> teklen zikloa nabarmendutako EI atalen barruan.</p>\n' +
  '\n' +
  '<p>Irekitako menu bat ixteko, ireki azpimenua, edo ireki menu gainerakorra, sakatu <strong>Ihes</strong> tekla.</p>\n' +
  '\n' +
  '<p>Une horretan fokuratzea EIko atal jakin baten "goialdean" badago, <strong>Ihes</strong> tekla sakatuz gero\n' +
  '  teklatuaren nabigaziotik irtengo zara.</p>\n' +
  '\n' +
  '<h1>Exekutatu menuko elementu bat edo tresna-barrako botoi bat</h1>\n' +
  '\n' +
  '<p>Nahi den menuaren elementua edo tresna-barraren botoia nabarmenduta dagoenean, sakatu <strong>Itzuli</strong>, <strong>Sartu</strong>\n' +
  '  edo <strong>Zuriune-barra</strong> elementua exekutatzeko.</p>\n' +
  '\n' +
  '<h1>Nabigatu fitxarik gabeko elkarrizketak</h1>\n' +
  '\n' +
  '<p>Fitxarik gabeko elkarrizketetan, lehen osagai interaktiboa fokuratzen da elkarrizketa irekitzen denean.</p>\n' +
  '\n' +
  '<p>Nabigatu elkarrizketa interaktiboko osagai batetik bestera <strong>Tabuladorea</strong> edo <strong>Maius+Tabuladorea</strong> sakatuta.</p>\n' +
  '\n' +
  '<h1>Nabigatu fitxadun elkarrizketak</h1>\n' +
  '\n' +
  '<p>Fitxadun elkarrizketetan, fitxa-menuko lehen botoia fokuratzen da elkarrizketa irekitzen denean.</p>\n' +
  '\n' +
  '<p>Nabigatu elkarrizketa-fitxa honen interaktiboko osagai batetik bestera <strong>Tabuladorea</strong> edo\n' +
  '  <strong>Maius+Tabuladorea</strong> sakatuta.</p>\n' +
  '\n' +
  '<p>Aldatu beste elkarrizketa-fitxa batera fitxa-menua fokuratu eta dagokion <strong>Gezia</strong>\n' +
  '  tekla sakatzeko, erabilgarri dauden fitxa batetik bestera txandakatzeko.</p>\n');